import React, { FC } from "react";

import { CsobDatasetComparison } from "@components/main/csob/DatasetComparison";

const DatasetComparisonPage: FC = () => {
  return <CsobDatasetComparison />;
};

export default DatasetComparisonPage;
